import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const CloseButton = ({
  onClose
}) => {
  return /*#__PURE__*/_jsx(Button, {
    onClick: onClose,
    disabled: !onClose,
    marginInlineStart: "0",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "taskFormsLib.footer.cancel"
    })
  }, "cancel-task-btn");
};
export default CloseButton;